// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"28401c859282d906","6079":"726eb804d4057c2a"}[chunkId] + ".css";
};